<template>
  <div class="menu" @click="open()">{{ infos.title }}</div>
</template>

<script>
export default {
  name: 'Menu-Overlay',
  props: {
    // infos can be either a plain string or an object with a `title` field
    infos: {
      type: [String, Object],
      default: () => '',
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    open() {
      this.$emit('send', 'open');
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {
  font-family: 'Vulf Sans Medium';
  font-size: 24px;
  position: fixed;
  top: 24px;
  z-index: 10000;
  right: 24px;
  cursor: pointer;
}
</style>
